import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'sd/'

const initialState = {
    invoiceForDB: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getInvoiceForDB = createAsyncThunk('sd/gifdb', async (userID, thunkAPI) => {

    try {
        const result = await axios.post(API_URL + 'getInvoiceForDB', userID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const salesDashbaordSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.invoiceForDB = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getInvoiceForDB.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getInvoiceForDB.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.invoiceForDB = action.payload
            })
            .addCase(getInvoiceForDB.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = salesDashbaordSlice.actions

export default salesDashbaordSlice.reducer